<template>
  <div class="l-dummy-img-box">
    <div
      v-for="n in column"
      :key="n"
      class="dummy-img-box"
    >
      <div class="dummy-img-box__avatar" />
      <div class="dummy-img-box__img" />
      <div class="dummy-img-box__contents">
        <div class="dummy-img-box__date" />
        <h3 class="dummy-img-box__title" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DummyCarousel',
  data () {
    return {
      column: 4
    }
  }
}
</script>

<style lang="scss" scoped>
$break-point: 768px;

.l-dummy-img-box {
  display: flex;
  width: 100%;
  height: 250px;
  overflow: hidden;
  margin: 20px 0;
}

.dummy-img-box {
  position: relative;
  flex: 0 0 264px;
  height: 250px;
  margin-right: 8px;
  background: white;

  @media screen and (min-width: $break-point) {
    flex: 0 0 247px;
    margin-right: 40px;
  }
}

.dummy-img-box__avatar {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 48px;
  height: 48px;
  border: 2px solid #dfdfdf;
  border-radius: 50%;
  background: #dfdfdf;
}

.dummy-img-box__img {
  width: 100%;
  height: 150px;
  background: #c5c5c5;
}

.dummy-img-box__contents {
  width: 100%;
  height: 100%;
  padding: 8px;
}

.dummy-img-box__date {
  width: 50%;
  height: 18px;
  margin-bottom: 8px;
  background: #dfdfdf;
}

.dummy-img-box__title {
  width: 100%;
  height: 20px;
  background: #dfdfdf;
}
</style>
